import React from 'react';
import { useAuth } from '../hooks/useAuth';
import LoadingSpinner from './ChatWidget/LoadingSpinner';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <LoadingSpinner size="large" text="Loading..." />
      </div>
    );
  }

  // Instead of redirecting, render the children component
  // The UserDashboard component will handle showing the login prompt
  return <>{children}</>;
};

export default PrivateRoute; 